import React from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { timeStampToDateWithTime } from "../../../utils/formats";
import { parseDecisionType } from "../../../pages/ViewCreditProposal/detail/analisecredito/sections/OpinionsSection";

import Modal from "../../Modal";
import FrontCredito from "../../../assets/navbar/Front_Credito_on_light_blue.svg";
import Input from "../../../pages/ViewCreditProposal/detail/Input";
import Button from "../../Button-v2";

const OpinionModal = (props) => {
  const {
    open,
    onClose,
    loading,
    sequencia,
    tipoParecer,
    decisao,
    nomeUsuario,
    dataHora,
    parecer,
  } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Header>
        <IconWrapper>
          <ReactSVG src={FrontCredito} />
        </IconWrapper>
        <TitleWrapper>
          <Title>Front de crédito</Title>
          <Subtitle>Análise de Crédito</Subtitle>
        </TitleWrapper>
      </Header>
      <Body>
        <Label>Último Parecer</Label>
        <Card>
          <Grid container spacing={3}>
            <Grid item xs={12} md={2}>
              <Input
                disabled
                loading={loading}
                label="Sequência"
                value={sequencia}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                disabled
                loading={loading}
                label="Tipo de parecer"
                value={tipoParecer}
                align="flex-start"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                disabled
                loading={loading}
                label="Decisão"
                value={parseDecisionType(decisao)}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Input
                disabled
                loading={loading}
                label="Nome Usuário"
                value={nomeUsuario}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                disabled
                label="Data/hora"
                loading={loading}
                value={timeStampToDateWithTime(dataHora)}
              />
            </Grid>
            <Grid item md={12}>
              <Input
                disabled
                label="Parecer"
                value={parecer}
                loading={loading}
                height={200}
                type="textarea"
                align="flex-start"
              />
            </Grid>
            <ButtonWrapper>
              <Button
                buttonTheme="goback"
                height="34px"
                width="150px"
                onClick={handleClose}
              >
                Fechar
              </Button>
            </ButtonWrapper>
          </Grid>
        </Card>
      </Body>
    </Modal>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;

  border-bottom: 3px solid #00a2e0;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;

  margin: 0px 5px;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 1.22;
  color: #383838;
`;

const Subtitle = styled.div`
  font-size: 15px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.2;
  color: #747576;
`;

const Body = styled.div`
  margin-top: 32px;
  width: 700px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;

  margin-top: 32px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => justify || "flex-start"};
  align-items: ${({ align }) => align || "center"};
  font-size: ${({ fontSize }) => (fontSize != undefined ? fontSize : "12px")};
  font-family: Roboto;
  width: ${({ width }) => (width != undefined ? width : "100%")};
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-top: ${({ marginTop }) => (marginTop != undefined ? marginTop : 0)}px;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom != undefined ? marginBottom : 10}px;
  height: ${({ height }) => (height != undefined ? height : "auto")};
`;

export const Card = styled.div`
  padding: 21px 19px 26.4px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;
`;

export default OpinionModal;
